// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608180624/js/" + chunkId + "." + {"44":"c77e2a4a","225":"602862d5","481":"33cb75f6","486":"2b360abf","770":"de59f2ce"}[chunkId] + ".0.7209322903074984.chunk.js";
};